import { PlusIcon as PhosphorPlusIcon } from "@phosphor-icons/react/dist/ssr/Plus";

import { createAppIcon } from "@/components/createAppIcon";

export const AddIcon = /* @__PURE__ */ createAppIcon(PhosphorPlusIcon);
